import api from './api'

/**
 * Player Import Service
 * Handles player import API calls
 */
class PlayerImportService {
  /**
   * Parse import file and return raw rows
   * POST v1/{club}/players/import/parse
   */
  async parseFile(clubUuid: string, source: string, file: File): Promise<{ source: string, rows: string[][] }> {
    const formData = new FormData()
    formData.append('source', source)
    formData.append('file', file)
    const response = await api.post(`v1/${clubUuid}/players/import/parse`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60000
    })
    return response.data
  }

  /**
   * Get indexes of rows matching existing players (first name + last name + birth date)
   * POST v1/{club}/players/import/duplicates
   */
  async checkDuplicates(clubUuid: string, players: Array<{ first_name: string, last_name: string, birth_date: string | null }>): Promise<number[]> {
    const response = await api.post(`v1/${clubUuid}/players/import/duplicates`, { players }, { timeout: 30000 })
    return response.data.duplicates
  }

  /**
   * Queue import
   * POST v1/{club}/players/import
   */
  async importPlayers(clubUuid: string, payload: { source: string, send_invitations: boolean, players: any[] }): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/players/import`, payload, { timeout: 60000 })
    return response.data
  }
}

export default new PlayerImportService()
